"use client"

import { ReactNode, useState } from "react"
import { SessionProvider } from "@/contexts/SessionContext"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { UserSession } from "@/types/session"

export function ClientProviders({
  children,
  session
}: {
  children: ReactNode
  session?: UserSession | null | undefined
}) {
  // Create QueryClient per-instance to prevent cross-request cache leaking in SSR
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5_000,
            refetchOnWindowFocus: true,
          },
        },
      })
  )

  return (
    <QueryClientProvider client={queryClient}>
      {/* Pass session as-is: undefined means "no info, please fetch", null means "known guest" */}
      <SessionProvider initialSession={session}>
        {children}
      </SessionProvider>
    </QueryClientProvider>
  )
}

// Legacy export for backward compatibility
export const Providers = ClientProviders
